import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import api from "../utils/axiosConfig";
import { useCart } from "../components/Cart/CartContext";

export default function PrivateRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = en cours de vérification
  const [loading, setLoading] = useState(true);
  const { resetCart } = useCart();
  const location = useLocation(); // 📍 pour connaître l'URL actuelle

  useEffect(() => {
    api.get('/api/auth/check')
      .then(() => {
        setIsAuthenticated(true);
        setLoading(false);
      })
      .catch(() => {
        setIsAuthenticated(false);
        setLoading(false);
        resetCart();
      });
  }, [resetCart]);

  if (loading) return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      fontFamily: "Georgia, serif"
    }}>
      <div style={{
        position: "relative",
        width: "60px",
        height: "60px",
        marginBottom: "1rem"
      }}>
        <div style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          border: "3px solid transparent",
          borderTop: "3px solid #4299e1",
          borderRadius: "50%",
          animation: "spin 1.5s linear infinite"
        }}></div>
        <div style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          border: "3px solid transparent",
          borderRight: "3px solid #38b2ac",
          borderRadius: "50%",
          animation: "spin 1.5s linear infinite",
          animationDelay: "0.5s"
        }}></div>
        <div style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          border: "3px solid transparent",
          borderBottom: "3px solid #ed8936",
          borderRadius: "50%",
          animation: "spin 1.5s linear infinite",
          animationDelay: "1s"
        }}></div>
      </div>
      <p style={{
        color: "#4a5568",
        fontSize: "1rem",
        fontWeight: "500",
        margin: "0"
      }}>Chargement en cours...</p>
    </div>
  );

  if (!isAuthenticated) {
    // ❗ Redirige avec l'URL d'origine en mémoire
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
